import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="offcanvas"
export default class extends Controller {
  static targets = ["container"];
  handle() {
    this.containerTarget.classList.toggle("hidden");
  }
}
